import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { HOME_ROUTE } from './home.route';
import { HomeComponent } from './home.component';
import { MonthlyUniqueVisitorComponent } from '../reports/monthly-unique-visitor/monthly-unique-visitor.component';
import { MonthlyVisitorsComponent } from '../reports/monthly-visitors/monthly-visitors.component';

import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [SharedModule, RouterModule.forChild([HOME_ROUTE])],
  declarations: [HomeComponent, MonthlyUniqueVisitorComponent, MonthlyVisitorsComponent],
})
export class HomeModule {}
